import { render, staticRenderFns } from "./ProductExtraGroups.vue?vue&type=template&id=aab2fe3e"
import script from "./ProductExtraGroups.vue?vue&type=script&lang=js"
export * from "./ProductExtraGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports